import styled from 'styled-components';

import { ReactComponent as Cube } from '../../../images/cubes/sq1.svg';

export const StyledSq1Cube = styled(Cube)`
    @media only screen and (max-width: 1036px) {
        transform: translateY(-40px);
    }
`;
